export enum INTERVIEW_ATTENDANCE {
  YES = "Yes, I'm In!",
  NO = "Can't Attend",
  RESCHEDULE = 'Can We Reschedule?',
}

export enum INTERVIEW_ATTENDANCE_SAVE_VALUES {
  YES = 'yes',
  NO = 'no',
  RESCHEDULE = 'reschedule',
}

export enum INTERVIEW_TYPE {
  TECHNICAL = 'technical',
  HR = 'hr',
}

export interface RescheduleReason {
  key: string;
  value: string;
}

export interface IInterviewResponse {
  attendance: string;
  rescheduleReason?: string;
  rescheduleDescription?: string;
}
